import { configureStore } from '@reduxjs/toolkit'
import rootReducer from 'slices'
import { persistAgentIdState } from 'lib/auth/tokenStorage'
import { resetAuth } from 'slices/auth'
import { resetGlobal } from 'slices/global'
import { resetCustomerSteps } from 'slices/customerSteps'
import { resetCustomerFiles } from 'slices/customerFiles'
import { resetCustomer } from 'slices/customer'
import { initializeApiCall } from 'slices/apiCallCheckSlice'
import { initializeSpeechCheckList } from 'slices/speechCheckListSlice'
import { initializeEligibilityCheckList } from 'slices/eligibilityCheckListSlice'
import { initializeSecurelink } from 'slices/securelinkslice'
import { initializeCustomerFiles } from 'slices/customerFiles'
import { initializePassport, initializePassportFiles } from 'slices/passport'
import { initializeMiscDoc } from 'slices/misc_doc'
import { initializePurchaseReceipt } from 'slices/purchaseReceiptSlice'
import { initializeTripAir } from 'slices/tripAirSlice'
import { initializeTripSea } from 'slices/tripseaSlice'
import { initializePaymentCards, initializeCreditCards } from 'slices/paymentCards'
import { initializeArnFiles } from 'slices/arn_files'
import { initializeAffiliateCompany } from 'slices/affiliateCompanySlice'
import { initializeAffiliateLocation } from 'slices/affiliateLocationSlice'
import { initializePdfData } from 'slices/pdfDataSlice'
import { initializePurchaseTotal } from 'slices/purchaseTotalSlice'
import { initializeIdleTime } from 'slices/idleTimeLock'
import { reduxLoggerMiddleware } from './reduxLoggerMiddleware'

const resolveAgentIdFromState = state =>
  state?.auth?.data?.current_user?.id ||
  state?.auth?.data?.user?.id ||
  state?.user?.current_user?.id ||
  state?.user?.id ||
  null

const appReducer = (state, action) => {
  if (action.type === 'RESET_STORE') {
    state = undefined
  }
  return rootReducer(state, action)
}

const store = configureStore({
  reducer: appReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST']
      }
    }).concat(reduxLoggerMiddleware)
})

store.subscribe(() => {
  persistAgentIdState(resolveAgentIdFromState(store.getState()))
})

export { store }

export const resetStore = () => {
  store.dispatch({ type: 'RESET_STORE' })
  store.dispatch(resetAuth())
  store.dispatch(resetGlobal())
  store.dispatch(resetCustomerSteps())
  store.dispatch(resetCustomerFiles())
  store.dispatch(resetCustomer())
  store.dispatch(initializeApiCall())
  store.dispatch(initializeTripAir())
  store.dispatch(initializeMiscDoc())
  store.dispatch(initializeArnFiles())
  store.dispatch(initializePdfData())
  store.dispatch(initializeSpeechCheckList())
  store.dispatch(initializeEligibilityCheckList())
  store.dispatch(initializeTripSea())
  store.dispatch(initializeSecurelink())
  store.dispatch(initializePaymentCards())
  store.dispatch(initializeCreditCards())
  store.dispatch(initializeAffiliateCompany())
  store.dispatch(initializeAffiliateLocation())
  store.dispatch(initializePurchaseReceipt())
  store.dispatch(initializePurchaseTotal())
  store.dispatch(initializeIdleTime())
}

export const setLocalStorageState = state => {
  persistAgentIdState(resolveAgentIdFromState(state))
}

// Reset only customer-related domain slices back to their initial state
export const resetCustomerDomain = () => {
  store.dispatch(initializeCustomerFiles())
  store.dispatch(initializePassport())
  store.dispatch(initializePassportFiles())
  store.dispatch(initializeMiscDoc())
  store.dispatch(initializePurchaseReceipt())
  store.dispatch(initializeTripAir())
  store.dispatch(initializeTripSea())
  store.dispatch(initializePaymentCards())
  store.dispatch(initializeCreditCards())
  store.dispatch(initializeArnFiles())
  store.dispatch(initializeAffiliateCompany())
  store.dispatch(initializeAffiliateLocation())
  store.dispatch(initializePdfData())
  store.dispatch(initializePurchaseTotal())
  store.dispatch(initializeIdleTime())
}
